<template>
  <div class="courseware vertical">
    <div class="courseware-box">
      <div class="courseware-content-box">
        <div class="title">
          <h2>
            {{ selectCoursewareInfo.attmName }}
          </h2>

          <div class="meun-box" v-if="!videoId">
            <p class="menu" @click="popoverShow = !popoverShow">
              <VIconFont class="icon" type="icon-zhangjie" />课程目录
            </p>

            <div class="popover-box" v-show="popoverShow">
              <OutlineList
                :distributeWay="distributeWay"
                :selectCourseId="selectCourseId"
                @selectBrowseCourse="selectBrowseCourse"
              />
            </div>
          </div>
        </div>

        <div v-if="coursewareType === '1'" class="courseware-content-img">
          <iframe :src="fileUrl"></iframe>
        </div>
        <div v-else-if="coursewareType === '2'" class="courseware-content-img">
          <!-- <VImg :attachment-id="coursewareFileId" /> -->
          <iframe :src="fileUrl"></iframe>
        </div>
        <div v-else-if="coursewareType === '3'">
          <video
            :src="fileUrl"
            ref="videoRef"
            controls
            autoplay
            @seeked="seeked"
            @play="play"
            @pause="pause"
            @ended="videoEnded"
            @canplay="canplay"
            :currentTime="currentTime"
            class="courseware-video"
          ></video>
        </div>
        <div
          v-else-if="coursewareType === '4'"
          style="display: flex; align-items: center; justify-content: center"
        >
          <audio
            :src="fileUrl"
            ref="videoRef"
            controls
            autoplay
            @seeked="seeked"
            @play="play"
            @pause="pause"
            @canplay="canplay"
            @ended="videoEnded"
            width="100%"
            height="100%"
          ></audio>
        </div>
        <div
          v-else-if="coursewareType === '5'"
          class="iframe-file"
          id="coursewareInfo"
        >
          <iframe :src="fileUrl"></iframe>
        </div>
        <div
          v-else-if="coursewareType === '6' || coursewareType === '7'"
          class="iframe-file"
          id="coursewareText"
        >
          <iframe :src="fileUrl"></iframe>
        </div>
        <div v-if="videoId">
          <video
            :src="fileUrl"
            controls
            autoplay
            class="courseware-video"
          ></video>
        </div>
        <p class="spinning-box"><a-spin :spinning="spinning" size="large" /></p>
      </div>
      <div class="courseware-summary-box">
        <CoursewareNote
          ref="CoursewareNoteRef"
          :coursewareType="coursewareType"
          :currentTime="currentTime"
          @changeTime="changeTime"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WebSocketClass from "@/utils/webSocket";
import { getStudyCourseContent } from "@/api/activity";
import { getAttachment } from "@/api/common";
import VImg from "@/components/VImg.vue";
import VIconFont from "@/components/iconFont.vue";
import CoursewareNote from "./components/CoursewareNote.vue";
import OutlineList from "./components/outlineList.vue";
import { mapGetters } from "vuex";
let wsValue = null; //websocket 服务
import { Base64 } from "js-base64";

export default {
  components: {
    VImg,
    CoursewareNote,
    OutlineList,
    VIconFont,
  },
  data() {
    return {
      selectCourseId: "",
      popoverShow: false,
      selectCoursewareInfo: {
        attmName: "",
      },
      coursewareType: "",
      outlineItemContentId: "",
      coursewareFileId: "",
      coursewareFileType: "",
      wordContainer: null,
      spinning: false,
      fileUrl: "",
      params: {},
      isPause: false,
      currentTime: "",
      distributeWay: "1",
    };
  },
  provide() {
    return {
      coursewareType: this.coursewareType,
      outlineItemContentId: this.outlineItemContentId,
      currentTime: this.currentTime,
      courseStudyId: this.courseStudyId,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    courseId: function () {
      return this.$route.query.courseId;
    },
    courseStudyId: function () {
      return this.$route.query.courseStudyId;
    },
    videoId: function () {
      return this.$route.query.videoId;
    },
  },
  beforeDestroy() {
    this.videoEnded();
  },
  mounted() {
    if (this.videoId) {
      this.fileUrl = `${process.env.VUE_APP_API_PORTAL_URL}/file/download/${this.videoId}`;
      this.loadAttachmentInfo(this.videoId);
      this.$refs.CoursewareNoteRef.loadList(this.courseStudyId, null);
    }
  },
  methods: {
    async loadAttachmentInfo(id) {
      const info = await getAttachment(id);
      this.selectCoursewareInfo.attmName = info.fileName;
    },
    createWs(id) {
      wsValue = new WebSocketClass(
        `${process.env.VUE_APP_WEBSOCKET_URI}/${id}`,
        () => {}
      );
      wsValue.connect();
    },

    async selectBrowseCourse(value) {
      this.fileUrl = "";
      this.spinning = true;
      this.coursewareType = "";
      this.coursewareFileType = "";
      this.currentTime = null;
      this.selectCourseId = value.id;
      this.selectCoursewareInfo = value;
      this.coursewareFileId = value.attachmentId;
      this.outlineItemContentId = value.id;
      this.$refs.CoursewareNoteRef.loadList(this.courseStudyId, value.id);
      setTimeout(() => {
        this.coursewareType = value.attmType;
      }, 100);
      if (value.attmType === "3" || value.attmType === "4") {
        this.fileUrl = `${process.env.VUE_APP_API_PORTAL_URL}/file/download/${value.attmId}`;
      } else {
        this.fileUrl =
          "http://124.70.52.112:50356/onlinePreview?url=" +
          encodeURIComponent(
            Base64.encode(
              `${process.env.VUE_APP_OBS_PREFIX}/${value.attmId}?fullfilename=${value.attmName}`
            )
          );
      }
      this.spinning = false;
      this.params = {
        chapterContentId: value.id,
        courseStudyId: this.courseStudyId,
        fileDuration: -1,
        studyTime: -1,
      };
      if (wsValue) wsValue.closeMyself();
      if (value.attmType === "3" || value.attmType === "4") {
      } else {
        this.params.studyTime = -1;
        getStudyCourseContent(this.params);
      }
    },

    videoEnded() {
      wsValue.closeMyself();
    },

    canplay() {
      this.params.studyTime = 0;
      this.params.fileDuration = Math.round(this.$refs.videoRef.duration);
      getStudyCourseContent(this.params).then((res) => {
        this.createWs(res.id);
      });
    },

    //暂停
    pause() {
      this.isPause = true;
      if (this.$refs.videoRef) {
        this.currentTime = this.$refs.videoRef.currentTime;
      }
    },

    //不在暂停
    play() {
      this.isPause = false;
      this.currentTime = null;
    },

    //移动
    seeked() {
      if (this.isPause) {
        this.currentTime = this.$refs.videoRef.currentTime;
      }
    },

    changeTime(time) {
      console.log(this.$refs.videoRef.currentTime, time);
      this.currentTime = time;
      this.$refs.videoRef.currentTime = time;
      console.log(this.$refs.videoRef.currentTime);
      // this.$refs.videoRef.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-file {
  > iframe {
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
    border-radius: 8px;
  }
}
.courseware-video {
  width: 100%;
  max-height: 100%;
  height: 660px;
  object-fit: fill;
}

.courseware {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f9fafc;
}

.courseware-box {
  flex: 1;
  .courseware-outline {
    width: 248px;
    background: #fff;
    height: 100%;
    padding: 32px 0;
    overflow-x: auto;
    > h2 {
      padding: 0 24px;
      font-size: 18px;
      font-weight: 600;
      color: #323233;
      line-height: 24px;
      margin-bottom: 29px;
    }
  }
  .courseware-content-box {
    flex: 1;
    padding: 40px;
    position: relative;
    .title {
      margin-bottom: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 20px;
        font-weight: bold;
        color: #323233;
        line-height: 24px;
      }
      .meun-box {
        position: relative;
        .menu {
          cursor: pointer;
          font-weight: 400;
          font-size: 16px;
          color: #646566;
          line-height: 22px;
          .icon {
            margin-right: 8px;
          }
          &:hover {
            color: #ff7c15;
          }
        }
        .popover-box {
          position: absolute;
          width: 264px;
          height: 600px;
          top: 30px;
          right: 0;
          overflow-y: auto;
          background-color: #fff;
          box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          z-index: 10;
        }
      }
    }

    > :not(:first-child) {
      border-radius: 8px;
    }

    .courseware-content-img {
      max-height: 100%;
      height: 660px;
      background: #ededed;
      border-radius: 8px;
      overflow: hidden;
      > img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
      iframe {
        width: 100%;
        height: 100%;
      }
    }
    .spinning-box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
  }
}

.cross {
  flex-shrink: 0;
  height: 0;
  .courseware-box {
    display: flex;
    flex-shrink: 0;
    height: 0;
  }
  .courseware-content-box {
    display: flex;
    flex-direction: column;
    > :not(:first-child) {
      flex: 1;
    }
  }
  .courseware-outline {
    overflow-y: auto;
  }
  .courseware-summary-box {
    width: 328px;
    background: #fff;
    height: 100%;
    overflow-y: auto;
  }
}

//竖
.vertical {
  .courseware-box {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
  }
  .courseware-content-box {
    padding: 0;
    .iframe-file {
      height: 627px;
    }
  }
  .courseware-summary-box {
    width: 100%;
    border-radius: 8px;
    background: #fff;
    margin-top: 24px;
  }
}
</style>
<style>
.courseware-content-box .docx-wrapper {
  background: #ededed;
}
.courseware-content-box .docx-wrapper > section.docx {
  box-shadow: none;
  border: 1px solid #dcdee0;
}
</style>
